/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  IAssured,
  IEAssured,
  IError,
  IErrorRapatriement,
  IValues,
  IshowErrorAssuredDefault,
  IshowErrorValuesDefault,
  IshowErrorValuesRapatriementDefault,
  ModalDataDTO,
} from '../../../types/interface/Assurance/AssuranceRapatriement/souscription';

export const showErrorAssuredDefault: IshowErrorAssuredDefault = {
  nom: false,
  prenom: false,
  dateNaissance: false,
  sexe: false,
  adressePostale: false,
  ville: false,
  paysResidence: false,
  email: false,
  telephone: false,
  countryCode: false,
  numCI: false,
  capture_file: false,
};

export const showErrorValuesDefault: IshowErrorValuesDefault = {
  montant: false,
  dateDebut: false,
  assure: [],
  agence: false,
};

export const showErrorValuesRapatriementDefault: IshowErrorValuesRapatriementDefault =
  {
    assure: [],
    dateDebut: false,
  };

export const showErrorAssuredSubmit = {
  nom: true,
  prenom: true,
  dateNaissance: true,
  sexe: true,
  adressePostale: true,
  ville: true,
  paysResidence: true,
  email: true,
  telephone: true,
  countryCode: true,
  numCI: true,
  capture_file: true,
};

export const showErrorValuesSubmit = {
  montant: true,
  dateDebut: false,
  assure: [],
  agence: true,
};

export const showErrorValuesRapatriementSubmit = {
  montant: true,
  assure: [],
  dateDebut: true,
};

export const defaultErrorAssured: IEAssured = {
  nom: '',
  prenom: '',
  dateNaissance: '',
  sexe: '',
  adressePostale: '',
  ville: '',
  paysResidence: '',
  email: '',
  telephone: '',
  countryCode: '',
  numCI: '',
  capture_file: '',
  lastCaptureFile: '',
  newImage: false,
};

export const defaultErrorValues: IError = {
  montant: '',
  dateDebut: '',
  userIsAssured: false,
  assure: [],
  agence: '',
};

export const defaultSouscriptionRapatriementErrorValues: IErrorRapatriement = {
  userIsAssured: false,
  assure: [],
  dateDebut: '',
};

export const defaultAssured: IAssured = {
  id: '',
  nom: '',
  prenom: '',
  dateNaissance: undefined,
  sexe: '',
  adressePostale: '',
  ville: '',
  paysResidence: '',
  email: '',
  telephone: '',
  countryCode: 'FR',
  numCI: '',
  capture_file: '',
  isEditable: true,
  isNew: true,
};

export const defaultValues: IValues = {
  userIsAssured: false,
  assure: [],
  quoteCode: '',
  dateDebut: new Date(),
};

export const rapatriementAgeGap = {
  adults1: {min: 18, max: 25},
  adults2: {min: 26, max: 45},
  adults3: {min: 46, max: 55},
  adults4: {min: 56, max: 60},
  adults5: {min: 61, max: 65},
  adults6: {min: 66, max: 80},
};

export const modalDatasModified = {
  title: 'Information',
  content: `En ajustant le nombre d'assurés, le devis que vous avez reçu ne sera plus applicable, et cela entraînera une modification du montant indiqué dans la partie récapitulative.`,
  btn1: 'OK',
  btn2: 'Annuler',
};

export const initModalData: ModalDataDTO = {
  status: false,
  title: '',
  content: '',
  btn1: '',
  btn2: '',
  handleBtn1: () => {},
  handleBtn2: () => {},
};

export const TitleLabels = {
  contractant: {
    nomPrenomBeneficiaire: 'Nom et prénom(s) du Bénéficiaire',
    dateNaissanceBeneficiaire: 'Date de naissance du Bénéficiaire ',
    telephoneBeneficiaire: 'Téléphone du Bénéficiaire',
    emailBeneficiaire: 'Email Bénéficiaire',
    nombreAnimauxDomestique: "Nombre d'animaux domestiques",
    adresse: 'Adresse ',
    montant: 'Prime TTC à payer (en Ariary)',
    dateEffet: "Date d'effet",
  },
};

export const AGE_MIN_RAPATRIEMENT = 18;
export const AGE_LIMIT_RAPATRIEMENT = 65;
export const AGE_LIMIT_NO_GARANTI_RAPATRIEMENT = 80;

export const DEFAULT_NATIONALITY = 'Malagasy';
export const DEFAULT_RIP_AGENCE = 'Antsahavola';
